import { Box, Button, Container, Typography, alpha } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { Link as RouterLink } from 'react-router';

const gold = '#C0202A';

export function NotFound() {
  return (
    <Box sx={{ background: '#080808', minHeight: '100vh', pt: { xs: 18, md: 22 }, pb: { xs: 12, md: 16 } }}>
      <Container maxWidth="md">
        <Typography variant="overline" sx={{ color: gold, display: 'block', mb: 2 }}>
          Page Not Found
        </Typography>
        <Typography
          variant="h1"
          sx={{ color: '#F2EDE4', fontSize: { xs: '2.6rem', md: '4.5rem' }, mb: 3, lineHeight: 1.05 }}
        >
          This page is not available.
        </Typography>
        <Typography variant="body1" sx={{ color: alpha('#F2EDE4', 0.6), lineHeight: 2, maxWidth: 560, mb: 5 }}>
          The service or page you are looking for may have moved. Return home to continue exploring Lindsey Enterprises.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          color="primary"
          size="large"
          startIcon={<HomeIcon />}
          sx={{ py: 1.7, px: 5, fontSize: '0.7rem', letterSpacing: '0.18em' }}
        >
          Home
        </Button>
      </Container>
    </Box>
  );
}
